export default __webpack_public_path__ + "static/media/digest-confirm-preview.edf20377.svg";